module.exports = __webpack_public_path__ + "../assets/img/8a4909ba893e4302f2e0b4a010d76432.svg";